import Image from 'next/image';
import type { StaticImageData } from 'next/image';
import homepageBg from '@/assets/images/header-backgrounds/homepage.jpg';
import penetrationTestsBg from '@/assets/images/header-backgrounds/penetration-tests.jpg';
import vulnerabilityAssessmentsBg from '@/assets/images/header-backgrounds/vulnerability-assessments.jpg';
import managedSiemBg from '@/assets/images/header-backgrounds/managed-siem.jpg';
import threatMonitoringBg from '@/assets/images/header-backgrounds/threat-monitoring.jpg';
import complianceConsultancyBg from '@/assets/images/header-backgrounds/compliance-consultancy.jpg';
import penetrationTestingBg from '@/assets/images/header-backgrounds/penetration-testing.png';
import socBg from '@/assets/images/header-backgrounds/soc.jpg';
import aboutBg from '@/assets/images/header-backgrounds/about.jpg';
import whitePapersBg from '@/assets/images/header-backgrounds/white-papers.jpg';
import partnersBg from '@/assets/images/header-backgrounds/partners.png';
import contactBg from '@/assets/images/header-backgrounds/contact.jpg';

interface HeaderBackgroundProps {
  styleController: string;
}

const HeaderBackground: React.FC<HeaderBackgroundProps> = ({ styleController }) => {
  const classes = styleController.split(' ');

  const getBackgroundImage = (): StaticImageData | null => {
    const pageClass = classes.find(className => className !== 'main' && className !== 'header');

    if (!pageClass) return null;

    switch (pageClass) {
      case 'index':
        return homepageBg;
      case 'infrastructure-testing':
      case 'mobile-application-testing':
      case 'penetration_testing_enterprise_pen_testing':
      case 'web-application-testing':
      case 'configuration-testing':
      case 'social-engineering':
      case 'red-team':
        return penetrationTestsBg;
      case 'vulnerability-scans':
      case 'asv-scans':
        return vulnerabilityAssessmentsBg;
      case 'managed-siem':
        return managedSiemBg;
      case 'ddos-mitigation':
        return threatMonitoringBg;
      case 'iso-27001':
      case 'outsourced-dpo':
      case 'gdpr':
      case 'digital-forensics':
      case 'incident-response':
        return complianceConsultancyBg;
      case 'enterprise-penetration-testing':
      case 'crest-ovs-app-testing':
      case 'cloud-penetration-testing':
      case 'network-penetration-testing':
      case 'penetration-testing':
      case 'pen-testing':
        return penetrationTestingBg;
      case 'soc':
      case 'soc2':
        return socBg;
      case 'about':
        return aboutBg;
      case 'resources':
      case 'white_papers':
        return whitePapersBg;
      case 'partners':
      case 'partner-resources':
        return partnersBg;
      case 'contact':
      case 'quote':
        return contactBg;
      default:
        return null;
    }
  };

  const backgroundImage = getBackgroundImage();

  if (!backgroundImage) return null;

  return (
    <div className="header-background-wrapper">
      <div className="header-background">
        <Image
          src={backgroundImage}
          alt=""
          priority
          quality={100}
          width={1265}
          height={845}
          style={{
            objectFit: 'cover',
            objectPosition: 'center'
          }}
        />
      </div>
    </div>

  );
};

export default HeaderBackground;